import React, { useEffect, useState } from "react";
import "aos/dist/aos.css";
import Aos from "aos";
import Header from "./Header";
import NavAction from "./NavAction";
import Skill from "./Skill";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Cerita2 from "../component/Cerita/Cerita2";
import Karya from "../component/Karya/Karya";
import Motivasi from "../component/Motivasi/Motivasi";
import Kontak from "../component/Kontak";

function Home() {
  const [titik, setTitik] = useState("🤔");
  const [dark, setDark] = useState(false);

  function handleDarkMode() {
    const darkDiv = document.getElementById("home");
    setDark(!dark);
    darkDiv.classList.toggle("dark");
    darkDiv.classList.toggle("bg-gray-800");
  }

  const classNav =
    "my-2 md:my-3 underline underline-offset-2 md:underline-offset-4 font-base decoration-4 transition-all duration-300 text-lg md:text-xl decoration-sky-500 text-slate-700 dark:text-gray-200";

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <div className="dark:bg-white bg-gray-800 dark " id="home">
      <div className="max-w-3xl mx-auto px-5 py-14 md:py-16 lg:py-20 relative">
        <button
          onClick={handleDarkMode}
          className="absolute top-6 right-6 md:top-8 md:right-8 lg:top-10 lg:right-10"
        >
          {dark ? (
            <i class="bi bi-brightness-high text-3xl animate-pulse"></i>
          ) : (
            <i class="bi bi-brightness-high-fill text-3xl text-white animate-pulse"></i>
          )}
        </button>
        <Router>
          <Switch>
            <Route exact path="/">
              <Header titik={titik} setTitik={setTitik} classNav={classNav} />
              <NavAction classNav={classNav} />
              <Skill />
            </Route>
            <Route path="/cerita">
              <Cerita2 />
            </Route>
            <Route path="/karya">
              <Karya />
            </Route>
            <Route path="/motivasi">
              <Motivasi />
            </Route>
            <Route path="/kontak">
              <Kontak />
            </Route>
          </Switch>
        </Router>
      </div>
    </div>
  );
}

export default Home;
